import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageVigo = props => {
  return <CityLandingPage cityKey="Vigo" cityConfig={cityContent.vigo} {...props} />;
};

export default LandingPageVigo;
